import { Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import AddIcon from "@material-ui/icons/AddOutlined";
import clsx from "clsx";
import emptyStateImage from "../../img/events_empty_state.svg";

const useEmptyStateClasses = makeStyles(() => ({
  container: {
    paddingTop: 150,
    paddingLeft: 0,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  paragraph: {
    width: 500,
    margin: 20,
  },
}));

function EmptyState({ onNewRule }) {
  const classes = useEmptyStateClasses();

  return (
    <div className={clsx(classes.container)}>
      <img
        className="mb-4"
        alt="Creating API Allowlist Rules"
        src={emptyStateImage}
        height={201}
        width={273}
      />
      <Typography component="h1" gutterBottom variant="h3">
        You {"haven't"} created any allowlist rules yet
      </Typography>
      <Typography component="p" className={classes.paragraph}>
        No network events are being captured right now by the Freshpaint SDK.
        Create allowlist rules to start capturing network events.
      </Typography>
      <Button color="primary" onClick={onNewRule} variant="contained">
        <AddIcon className={classes.icon} />
        Create Allowlist Rule
      </Button>
    </div>
  );
}

export default EmptyState;
